import { Link } from 'react-router-dom';

export default function GamesPage() {
    return (
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            {/* Header */}
            <div className="text-center mb-10 animate-fade-in">
                <div className="inline-block bg-primary-950 text-primary-300 border border-primary-500/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-2">
                    Fall 2026 Programs
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold text-white mb-3">
                    Games & <span className="text-primary-500">Roles</span>
                </h1>
                <p className="text-secondary-200 text-base md:text-lg max-w-2xl mx-auto">
                    Fall 2026 focuses on championship-level <strong>Super Smash Bros. Ultimate</strong> competition and our brand new <strong>Production & Broadcasting Crew</strong>.
                </p>
            </div>

            {/* Quick Track Switcher / Summary */}
            <div className="grid md:grid-cols-2 gap-6 mb-10">
                {/* Smash Bros Card */}
                <div className="card border-2 border-secondary-700 bg-secondary-900 p-6 flex flex-col justify-between">
                    <div>
                        <div className="flex items-center justify-between mb-4">
                            <div className="w-12 h-12 bg-red-600/20 rounded-xl flex items-center justify-center text-2xl" aria-hidden="true">
                                ⚔️
                            </div>
                            <span className="bg-green-600 text-white text-xs font-bold px-2 py-1 rounded">
                                ESRB: E10+
                            </span>
                        </div>
                        <h2 className="text-2xl font-display font-bold text-white mb-1">
                            Super Smash Bros. Ultimate
                        </h2>
                        <p className="text-xs text-primary-400 font-semibold uppercase tracking-wider mb-3">
                            Competitive Team • Nintendo Switch
                        </p>
                        <p className="text-secondary-200 text-sm mb-4 leading-relaxed">
                            Fast-paced platform fighter featuring iconic characters. Students compete in both individual Solos brackets and collaborative 3v3 Crews matches representing Peck High School.
                        </p>

                        <div className="bg-secondary-800 rounded-lg p-3.5 border border-secondary-700 mb-4 text-xs space-y-1.5 text-secondary-200">
                            <div><strong className="text-white">Divisions:</strong> High School Solos, Middle School Solos (Grade 8, ages 13+), HS Varsity Crews (3v3), HS JV Crews (3v3)</div>
                            <div><strong className="text-white">Schedule:</strong> Mondays & Tuesdays, 3:00 – 5:00 PM</div>
                            <div><strong className="text-white">Equipment:</strong> 4 school Switches + player BYO overflow</div>
                        </div>

                        <div className="bg-secondary-950/60 rounded-lg p-3.5 border border-secondary-800 text-xs">
                            <span className="text-primary-400 font-bold block mb-1">📚 Educational & Athletic Value</span>
                            <p className="text-secondary-300 leading-relaxed">
                                Rapid spatial decision-making, frame-data analysis, reaction speed, competitive resilience, and deep teamwork in the Crews format.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Production & Broadcasting Track Card */}
                <div className="card border-2 border-primary-500/50 bg-gradient-to-b from-primary-950/40 to-secondary-900 p-6 flex flex-col justify-between">
                    <div>
                        <div className="flex items-center justify-between mb-4">
                            <div className="w-12 h-12 bg-yellow-400/20 rounded-xl flex items-center justify-center text-2xl" aria-hidden="true">
                                🎬
                            </div>
                            <span className="bg-yellow-400 text-primary-950 text-xs font-extrabold px-2 py-1 rounded uppercase">
                                New for Fall 2026
                            </span>
                        </div>
                        <h2 className="text-2xl font-display font-bold text-white mb-1">
                            Production & Broadcasting Crew
                        </h2>
                        <p className="text-xs text-yellow-400 font-semibold uppercase tracking-wider mb-3">
                            Media & Broadcast Staff • PC & Studio Gear
                        </p>
                        <p className="text-secondary-200 text-sm mb-4 leading-relaxed">
                            For students interested in voice, media, live events, or graphic design. Run our live broadcasts, call matches on the microphone, and manage the team's public media.
                        </p>

                        <div className="bg-secondary-800 rounded-lg p-3.5 border border-secondary-700 mb-4 text-xs space-y-1.5 text-secondary-200">
                            <div><strong className="text-white">Key Roles:</strong> Play-by-Play Casters, Color Commentators, Stream Tech (OBS), Graphics & Overlays, Social Media & Highlights</div>
                            <div><strong className="text-white">Schedule:</strong> Focus on Wednesdays + live match days (Mon–Wed 3–5 PM)</div>
                            <div><strong className="text-white">Equipment:</strong> 6 RTX 5060 gaming PCs, OBS studio, DaVinci Resolve, Adobe Creative Cloud</div>
                        </div>

                        <div className="bg-secondary-950/60 rounded-lg p-3.5 border border-secondary-800 text-xs">
                            <span className="text-yellow-400 font-bold block mb-1">📚 Real-World Skills & Portfolio</span>
                            <p className="text-secondary-300 leading-relaxed">
                                Live audio mixing, video switcher operation, broadcast commentary, digital marketing, graphic design, and content creation.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Additional Titles Callout */}
            <div className="card bg-secondary-900 border border-secondary-700 p-6 mb-10">
                <div className="flex items-start gap-4">
                    <div className="text-3xl shrink-0" aria-hidden="true">💡</div>
                    <div>
                        <h3 className="text-lg font-bold text-white mb-1">Additional Games (Case-by-Case Evaluation)</h3>
                        <p className="text-secondary-200 text-sm leading-relaxed mb-2">
                            Titles such as <strong>Madden NFL 26</strong> or other MiHSEF titles will be evaluated on a case-by-case basis at the <strong>September 1st Parent & Student Info Meeting</strong> based on student interest, equipment availability, and coaching capacity.
                        </p>
                        <p className="text-secondary-300 text-xs">
                            If you are interested in competing in another game, please attend the meeting on Sept 1 or note it in the "Other" field on the Google Signup Form!
                        </p>
                    </div>
                </div>
            </div>

            {/* Parent Guide Banner */}
            <div className="card border-blue-500/30 bg-blue-950/20 p-6 mb-10">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div>
                        <h3 className="text-lg font-display font-bold text-blue-400 mb-1 flex items-center gap-2">
                            <span aria-hidden="true">👨‍👩‍👧</span> Parent & Administrator Transparency
                        </h3>
                        <p className="text-secondary-200 text-xs sm:text-sm">
                            All games are evaluated for age-appropriateness and educational value. In-game purchases and unmoderated open voice chats are strictly disabled during school competitions.
                        </p>
                    </div>
                    <Link to="/parents" className="btn-primary shrink-0 text-xs py-2 focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none">
                        View Parents Guide →
                    </Link>
                </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-4 border-t border-secondary-800">
                <Link to="/signups" className="btn-secondary text-sm focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none">
                    ← Signups & Forms
                </Link>
                <Link to="/schedule" className="btn-primary text-sm focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none">
                    View Schedule →
                </Link>
            </div>
        </div>
    );
}


